import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../app/store';

interface offchainDIDResolverState {
    did: string;
    didDoc: string;
}

const initialState: offchainDIDResolverState = {
    did: '',
    didDoc: ''
};

export const offchainDIDResolverSlice = createSlice({
    name: 'offchain-did-resolver',
    initialState,
    reducers: {
        setDID: (state, action: PayloadAction<string>) => {
            state.did = action.payload;
        },
        setDIDDocument: (state, action: PayloadAction<string>) => {
            state.didDoc = action.payload;
        }
    }
});

export const { setDID, setDIDDocument } = offchainDIDResolverSlice.actions;

export const _did = (state: RootState) => state.offchainDIDResolver.did;
export const _didDoc = (state: RootState) => state.offchainDIDResolver.didDoc;

export default offchainDIDResolverSlice.reducer;
